
import {
    FORM_TYPE,
    INPUT_HIDDEN_CONFIRMATION_EMAIL,
    INPUT_HIDDEN_URL_LP,
} from 'Constant';
import { INPUT_LAND_FIXED_VALUE } from '../constant';
import { ILandUseFormData, ILandUseJsonDto, IRegistrationFormData } from '../interface';

/**
 * generates POST Object for api
 * @param formData
 */
export const preparePostData = (formData: IRegistrationFormData): FormData => {

    const gigagemeinde = (window as any).additionalPageOptions.gemeinde;
    const lpUrlInputElement = document.getElementById(INPUT_HIDDEN_URL_LP) as HTMLInputElement;
    const lpUrlValue = lpUrlInputElement ? lpUrlInputElement.value : '';

    const confirmationEmail = document.getElementById(INPUT_HIDDEN_CONFIRMATION_EMAIL) as HTMLInputElement;
    const confirmationEmailValue = confirmationEmail ? confirmationEmail.value : '';

    const paramData = {
        json: 1,
        decodeUtf8: true,
        title: formData.title,
        firstname: formData.firstname,
        lastname: formData.lastname,
        phone: formData.phone,
        address: formData.street,
        number: formData.houseNumber,
        company: formData.company,
        email: formData.email,
        plz: formData.zipcode,
        city: formData.city,
        Einfamilienhaus: formData.einfamilienhaus || false,
        Mehrfamilienhaus: formData.mehrfamilienhaus || false,
        Gewerbeobjekt: formData.gewerbeobjekt || false,
        Privatkunden: formData.privatkunden || false,
        Selbstaendige: formData.selbstaendige || false,
        Unternehmen: formData.unternehmen || false,
        confirmation: formData.confirmation,
        customer: true,
        gemeinde: gigagemeinde,
        formulartype: FORM_TYPE,
        std_url: lpUrlValue,
        confirmationEmail: confirmationEmailValue,
    };

    const postFormData = new FormData();
    const all = Object.keys(paramData);
    const allLength = all.length;

    for (let i = 0; i < allLength; i++) {
        postFormData.append(all[i], paramData[all[i]]);
    }

    return postFormData;
};

/**
 * Generates LandUse form JSON Object from form data
 * @param formData
 */
export const getLandUsePostJson = (formData: ILandUseFormData): ILandUseJsonDto => {

    const responseJson: ILandUseJsonDto = {};

    responseJson.personal_data = {
        sex: formData.title,
        firstname: formData.firstname,
        lastname: formData.lastname,
        phone: formData.phoneNumber,
        phone_areacode: formData.phoneAreaCode,
        address: formData.street,
        housenumber: formData.houseNumber,
        plz: formData.zipcode,
        city: formData.city,
        email: formData.email,
        confirmation: formData.confirmation,
        birthday: formData.personalBirthday,
        company: formData.company,
        personal_country: INPUT_LAND_FIXED_VALUE, // https://jira.wf-de.vodafone.com/projects/ADTDXC6/issues/ADTDXC6-531
        personal_address: formData.personalStreet,
        personal_housenumber: formData.personalHouseNumber,
        personal_plz: formData.personalZipcode,
        personal_city: formData.personalCity,
        floor_number: formData.floornumber,
        district: formData.district,
    };

    responseJson.is_represented_by = formData.representedByCheck;

    if (responseJson.is_represented_by) {
        responseJson.represented_by = {
            firstname: formData.representedByFirstname,
            lastname: formData.representedByLastname,
            address: formData.representedByStreet,
            housenumber: formData.representedByHouseNumber,
            plz: formData.representedByZipcode,
            city: formData.representedByCity,
            email: formData.representedByEmail,
            company: formData.representedByCompany,
            country: INPUT_LAND_FIXED_VALUE, // https://jira.wf-de.vodafone.com/projects/ADTDXC6/issues/ADTDXC6-531
            birthday: formData.representedByBirthday,
            phone: formData.representedByPhoneNumber,
            phone_areacode: formData.representedByPhoneAreaCode,
        };
    }

    responseJson.residental_building = {
        residental_units: +formData.nubmerOfResidence,
        business_units: +formData.nubmerOfBusinessUnit,
    };

    responseJson.gemeinde = (window as any).additionalPageOptions.gemeinde;

    return responseJson;
};
